<template>
  <svg
    class="card-brand"
    :width="width"
    :height="height"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="32" rx="4" fill="white" />
    <g clip-path="url(#clip0_10096_3774)">
      <path
        d="M20.1497 10.855L15.9602 21.172H13.2268L11.1652 12.9386C11.04 12.4315 10.9312 12.2457 10.5505 12.032C9.92933 11.684 8.903 11.3577 8 11.1551L8.06133 10.855H12.4612C13.022 10.855 13.5262 11.2404 13.6535 11.907L14.7423 17.8769L17.4333 10.855H20.1497ZM30.8595 17.8036C30.8705 15.0806 27.2115 14.9306 27.2367 13.7142C27.2445 13.3441 27.586 12.9505 28.3335 12.85C28.704 12.7999 29.7248 12.7618 30.8827 13.3117L31.3368 11.1239C30.7147 10.8908 29.9142 10.6665 28.9182 10.6665C26.3623 10.6665 24.5637 12.0688 24.5485 14.0769C24.532 15.5621 25.8323 16.3909 26.812 16.8845C27.8198 17.3899 28.158 17.7147 28.1542 18.1667C28.147 18.8588 27.3503 19.1643 26.6058 19.1763C25.3062 19.197 24.552 18.8134 23.9508 18.5249L23.4822 20.7851C24.0863 21.0712 25.2015 21.3208 26.3577 21.3333C29.0742 21.3333 30.8512 19.9484 30.8595 17.8036ZM37.6085 21.1722H40L37.9125 10.855H35.7052C35.2088 10.855 34.7902 11.1533 34.6048 11.6119L30.7247 21.172H33.4398L33.979 19.6308H37.2965L37.6087 21.172L37.6085 21.1722ZM34.7233 17.5165L36.0843 13.6429L36.8677 17.5165H34.7235H34.7233ZM23.8443 10.855L21.7062 21.172H19.1205L21.2595 10.855H23.8443Z"
        fill="#1434CB"
      />
    </g>
    <defs>
      <clipPath id="clip0_10096_3774">
        <rect width="32" height="12" fill="white" transform="translate(8 10)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: Number,
    required: false,
    default: 48
  },
  height: {
    type: Number,
    required: false,
    default: 32
  }
})
</script>

<style lang="scss" scoped>
.card-brand {
  display: flex;
  border: solid 1px $gray-2;
  border-radius: 4px;
  box-sizing: border-box;
}
</style>
